import { Link, useLocation } from "react-router-dom";

import type { PublishedNavigationElement } from "@/lib/api/types";
import { useLandWarning } from "@/features/dashboard/components/warning-tool/use-land-warning";
import { useWarningPageNavLabel } from "@/features/shared/hooks/use-warning-page-defaults";
import { navigationElementIcon } from "@/lib/navigation-element-kinds";

import NavigationItem from "./navigation-item";

export default function NavigationWarningPageLink({
  element,
}: {
  element: PublishedNavigationElement;
}) {
  const { pathname } = useLocation();
  const { selectedDashboard, indicator } = useLandWarning();
  const navLabel = useWarningPageNavLabel();

  if (!selectedDashboard) return null;

  const url = element.full_path;

  return (
    <Link to={url} tabIndex={0}>
      <NavigationItem
        icon={navigationElementIcon(element)}
        active={pathname === url}
        dot={indicator && { color: indicator.color, label: indicator.label }}
      >
        {navLabel(element)}
      </NavigationItem>
    </Link>
  );
}
